import { Button } from "../../../components/core/basic/Button";
import { Modal } from "../../../components/core/basic/Modal";
import { trellisPalette } from "../../../components/custom/analytics/palettes";
import { useImportableAmazonProfiles } from "../../../components/custom/onboarding/useAmazonProfiles";
import { useState } from "react";
import { Link, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { setChannel } from "../../../redux/reducers/channel";

const AvailableProfilesModal = () => {
  const { t } = useTranslation(["merchandising", "common"]);
  const [modalDismissed, setModalDismissed] = useState(false);

  const navigate = useNavigate();
  const channel = useAppSelector((state) => state.channel);
  const dispatch = useAppDispatch();

  const { data: importableProfiles } = useImportableAmazonProfiles();

  return importableProfiles?.length && !modalDismissed ?
      <Modal
        isOpen={true}
        onOpenChange={(isOpen) => {
          if (!isOpen) {
            setModalDismissed(true);
          }
        }}
        title={t(($) => $.merchandising["Available Advertising Profiles"])}
        css={{
          padding: "xlarge",
          width: "50vw",
        }}
      >
        <p className="text-center w-75 mx-auto">
          {t(
            ($) =>
              $.merchandising[
                "More profiles from your Amazon Advertising account are available to connect to Trellis."
              ],
            {
              count: importableProfiles.length,
            },
          )}{" "}
          <br />
          {t(($) => $.merchandising["Visit the"])}{" "}
          <Link
            to="/user/amzsummary"
            search={{ modal: "profileImport" }}
            className="fw-bold"
            style={{ color: trellisPalette[10] }}
          >
            {t(($) => $.merchandising["Amazon Connect"])}
          </Link>{" "}
          {t(($) => $.merchandising["page to import them."])}
        </p>
        <div className="d-flex gap-5 justify-content-center pt-5">
          <Button variant="secondary" onPress={() => setModalDismissed(true)}>
            {t(($) => $.common.actions["Cancel"])}
          </Button>
          <Button
            onPress={() => {
              if (channel.currentChannel !== "amazon") {
                dispatch(setChannel("amazon"));

                localStorage.channel = "amazon";
              }
              setModalDismissed(true);
              navigate({ to: "/user/amzsummary", search: { modal: "profileImport" } });
            }}
          >
            {t(($) => $.merchandising["View Available Profiles"])}
          </Button>
        </div>
      </Modal>
    : null;
};

export default AvailableProfilesModal;
